"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _commissionBaseDeductionSetting = require("@/api/orderManagement/commissionBaseDeductionSetting");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'IllegalOrder',
  data: function data() {
    var validateFile = function validateFile(rule, value, callback) {
      if (value.length === 0) {
        callback(new Error('请上传文件'));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      activeName1: 'first',
      excelUrl: 'https://zf-pub-dev.oss-cn-hangzhou.aliyuncs.com/activity/2rN26x2e.xlsx',
      documentName: '下载模板-违规订单',
      ruleForm: {
        platformCode: '',
        handleType: 1,
        dateType: null,
        handleTxt: null,
        startTime: null,
        endTime: null,
        fileList: []
      },
      rules: {
        platformCode: [{
          required: true,
          message: '请选择平台类型',
          trigger: 'change'
        }],
        handleType: [{
          required: true,
          message: '请选择处理类型',
          trigger: 'change'
        }],
        dateType: [{
          required: true,
          message: '请选择时间类型',
          trigger: 'change'
        }],
        startTime: [{
          type: 'date',
          required: true,
          message: '请选择时间',
          trigger: 'change'
        }],
        handleTxt: [{
          required: true,
          message: '请选择处理原因',
          trigger: 'change'
        }],
        fileList: [{
          required: true,
          message: '请上传文件',
          validator: validateFile,
          trigger: 'change'
        }]
      },
      loading: false,
      queryData: {
        platformCode: null,
        name: '',
        // 文件名
        handleType: null,
        importStatus: null,
        page: {
          page: 1,
          size: 10
        }
      },
      tableData: [],
      total: 0,
      platformCodeMap: {
        TB: '淘宝',
        PDD: '拼多多',
        JD: '京东',
        SN: '苏宁',
        WPH: '唯品会'
      }
    };
  },
  created: function created() {
    this.violatedOrderRecord();
  },
  methods: {
    open: function open() {
      this.dialogVisible = true;
    },
    onClose: function onClose() {
      var _this = this;
      if (this.ruleForm.fileList.length > 0) {
        this.$confirm('文件未上传，是否关闭?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this.dialogVisible = false;
          _this.resetForm('ruleForm');
        }).catch(function () {
          return;
        });
      } else {
        this.dialogVisible = false;
        this.resetForm('ruleForm');
      }
      this.onInitialize();
      this.activeName1 = 'first';
    },
    handleClick: function handleClick(tab, event) {
      this.locationName = tab.label;
      console.log('tab.label', tab.label);
      if (tab.label === '违规订单处理记录') {
        this.onInitialize();
      }
    },
    // 订单导入
    changeHandleType: function changeHandleType(val) {
      if (val === 1) {
        this.excelUrl = 'https://zf-pub-dev.oss-cn-hangzhou.aliyuncs.com/activity/2rN26x2e.xlsx';
        this.documentName = '下载模板-违规订单';
      } else {
        this.excelUrl = 'https://zf-pub-dev.oss-cn-hangzhou.aliyuncs.com/activity/Nssms37a.xlsx';
        this.documentName = '下载模板-渠道单';
      }
    },
    change: function change(file, fileList) {
      this.handleRemove();
      this.ruleForm.fileList = [file]; // 覆盖之前选择的文件
      this.$refs.ruleForm.validateField('fileList');
    },
    handleRemove: function handleRemove() {
      this.ruleForm.fileList = [];
    },
    violatedOrderImport: function () {
      var _violatedOrderImport2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(FormData) {
        var res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _commissionBaseDeductionSetting.violatedOrderImport)(FormData);
            case 1:
              res = _context.v;
              console.log(res);
              if (res.data) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.resetForm('ruleForm');
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function violatedOrderImport(_x) {
        return _violatedOrderImport2.apply(this, arguments);
      }
      return violatedOrderImport;
    }(),
    formatDate: function formatDate(date) {
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      var hours = String(date.getHours()).padStart(2, '0');
      var minutes = String(date.getMinutes()).padStart(2, '0');
      var seconds = String(date.getSeconds()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    },
    submitForm: function () {
      var _submitForm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(formName) {
        var _this2 = this;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.$refs[formName].validate(function (valid) {
                if (valid) {
                  var obj = new FormData();
                  obj.append('file', _this2.ruleForm.fileList[0].raw);
                  obj.append('platformCode', _this2.ruleForm.platformCode);
                  obj.append('handleType', _this2.ruleForm.handleType);
                  if (_this2.ruleForm.handleType === 2) {
                    obj.append('dateType', _this2.ruleForm.dateType);
                    if (_this2.ruleForm.startTime !== null) {
                      obj.append('startTime', _this2.formatDate(_this2.ruleForm.startTime));
                    }
                    if (_this2.ruleForm.endTime !== null) {
                      obj.append('endTime', _this2.formatDate(_this2.ruleForm.endTime));
                    }
                  }
                  obj.append('handleTxt', _this2.ruleForm.handleTxt);
                  _this2.violatedOrderImport(obj);
                } else {
                  console.log('error submit!!');
                  return false;
                }
              });
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function submitForm(_x2) {
        return _submitForm.apply(this, arguments);
      }
      return submitForm;
    }(),
    resetForm: function resetForm(formName) {
      this.ruleForm = {
        platformCode: '',
        handleType: 1,
        dateType: null,
        handleTxt: null,
        startTime: null,
        endTime: null,
        fileList: []
      };
      this.excelUrl = 'https://zf-pub-dev.oss-cn-hangzhou.aliyuncs.com/activity/2rN26x2e.xlsx';
      this.documentName = '违规订单(订单号)';
      this.$refs[formName].resetFields();
    },
    // 处理记录
    violatedOrderRecord: function () {
      var _violatedOrderRecord2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var res, _t2;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return (0, _commissionBaseDeductionSetting.violatedOrderRecord)(this.queryData);
            case 1:
              res = _context3.v;
              console.log(res);
              if (res.data) {
                this.tableData = res.data.data;
                this.total = res.data.total;
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t2 = _context3.v;
              console.log(_t2);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function violatedOrderRecord() {
        return _violatedOrderRecord2.apply(this, arguments);
      }
      return violatedOrderRecord;
    }(),
    onInquire: function onInquire() {
      this.queryData.page.page = 1;
      this.violatedOrderRecord();
    },
    onInitialize: function onInitialize() {
      this.queryData = {
        platformCode: null,
        name: '',
        // 文件名
        handleType: null,
        importStatus: null,
        page: {
          page: 1,
          size: 10
        }
      };
      this.violatedOrderRecord();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.page.size = val;
      this.violatedOrderRecord();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page.page = val;
      this.violatedOrderRecord();
    },
    viewDetails: function viewDetails(id) {
      this.$emit('viewDetails', id);
    }
  }
};